<overlay-scrollbars [options]="prodInfoOptions" class="row row-m-20 product-info-container">
    <div [formGroup]="formDataBinding" class="col-12 col-p-20 py-4 mx-auto my-0">
        <div>
            <label class="section-title" cvLocalizedText
                langSection="MarketPlace_Management" langKey="Product_Details">Product Details</label>
            <hr class="m-0">
        </div>
        <div class="row mb-2 mt-20-px">
            <div class="col-6 col-md-6 col-lg-4">
                <label class="col-form-label text-uppercase cxone-label-title-form-element pt-0"><span cvLocalizedText langSection="MarketPlace_Management"
                        langKey="Title">Title</span><span class="required-sign"> *</span></label>
                <sol-text-input #titleInput inputAutoFocus formControlName="title" type="text" class="text-input" id="text-input-1"
                    [placeholder]="getLocalizationString('Enter_Product_Title','Enter product title')"
                    (keyup)="formDataBinding.controls['title'].setValue($event.target['value'].trimStart())"
                    (change)="pspes.modifiedPointStoreProduct.Title = $event.target['value'].trimStart()"
                    name="name"></sol-text-input>
                <div class="d-flex justify-content-between align-items-start">
                    <div>
                        <div class="error" *ngIf="formDataBinding.controls['title'].errors?.required && 
                            (formDataBinding.controls['title'].touched || formDataBinding.controls['title'].dirty)">
                            <span cvLocalizedText langSection="MarketPlace_Management_Messages" langKey="Field_Required">This field is required</span>
                        </div>
                        <div class="error" *ngIf="formDataBinding.controls['title'].errors?.titleExists && 
                            (formDataBinding.controls['title'].touched || formDataBinding.controls['title'].dirty)">
                            <span cvLocalizedText langSection="MarketPlace_Management_Messages" langKey="Product_Title_Exist">Product title already exists</span>
                        </div>
                        <div class="error" *ngIf="formDataBinding.controls['title'].hasError('forbiddenCharacters') && 
                            (formDataBinding.controls['title'].touched || formDataBinding.controls['title'].dirty)">
                            <span>{{ forbiddenCharactersMessage }}</span>
                        </div>
                        <div class="error" *ngIf="formDataBinding.controls['title'].errors?.maxlength && 
                            (formDataBinding.controls['title'].touched || formDataBinding.controls['title'].dirty)">
                            <span cvLocalizedText langSection="MarketPlace_Management_Messages" langKey="Entry_Long">This entry is
                                too long.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-12 col-md-12 col-lg-8">
                <label class="col-form-label text-uppercase cxone-label-title-form-element" cvLocalizedText langSection="MarketPlace_Management"
                    langKey="Description">Description</label>
                <sol-text-area formControlName="description"
                    #descriptionTextArea
                    [placeholder]="getLocalizationString('Enter_Product_Description', 'Enter product description')"
                    (keyup)="formDataBinding.controls['description'].setValue($event.target['value'].trimStart())"
                    (change)="pspes.modifiedPointStoreProduct.Description = $event.target['value'].trimStart()"
                    id="text-area-2" [resizeTextarea]="true">
                     </sol-text-area>
                <div class="d-flex justify-content-between align-items-start">
                    <div>
                        <div class="error" *ngIf="formDataBinding.controls['description'].errors?.maxlength && 
                            (formDataBinding.controls['description'].touched || formDataBinding.controls['description'].dirty)">
                        <span cvLocalizedText langSection="MarketPlace_Management" langKey="Entry_Too_Long">This entry is
                                too long.</span>
                        </div>
                        <div class="error" *ngIf="formDataBinding.controls['description'].hasError('forbiddenCharactersDescription') && 
                            (formDataBinding.controls['description'].touched || formDataBinding.controls['description'].dirty)">
                        <span cvLocalizedText langSection="MarketPlace_Management_Messages" langKey="Cannot_Use"> Cannot use</span><span> \ / + < > # & %</span>
                        </div>
                    </div>
                    <p class="description-counter" [class.error]="formDataBinding.controls['description'].value?.length>500">{{formDataBinding.controls['description'].value?.length || 0}}/500</p>
                </div>
                
            </div>
        </div>
        <!-- / -->
        <div class="row justify-content-start mb-2">
            <div class="col-6 col-md-6 col-lg-4 productDateFromContainer">
                <label class="col-form-label text-uppercase cxone-label-title-form-element" cvLocalizedText
                    langSection="MarketPlace_Management" langKey="Available_From">Available from
                </label>
                <span class="required-sign"> *</span>
                <sol-date-picker mode="page" [(ngModel)]="productStart" (ngModelChange)="productStart = setProductStart($event)"
                    [ngModelOptions]="{standalone: true}" datePickerContainer=".productDateFromContainer"
                    [class]="validatorService.displayError(formDataBinding.controls['productStart']) ? 'error-selector' : ''">
                </sol-date-picker>
            </div>
            <div class="col-6 col-md-6 col-lg-4 productDateUntilContainer">
                <div class="align-items-center justify-content-between d-flex">
                    <label class=" col-form-label text-uppercase cxone-label-title-form-element text-truncate" cvLocalizedText langSection="MarketPlace_Management"
                    langKey="Available_Until">Available until
                    </label>
                    <div class="justify-content-end d-flex text-truncate">
                    <sol-checkbox [(ngModel)]="noEndateCheckbox" [ngModelOptions]="{standalone: true}"
                        id="cxone-checkbox-no-end-date" class="text text-truncate" type="checkbox"  (clicked)="disableEndDate()"
                        ></sol-checkbox>
                        <span class="text-truncate" cvLocalizedText langSection="MarketPlace_Management"
                        langKey="No_End_Date">No end date</span>
                    </div>
                </div>
                <sol-date-picker datePickerId="dpProductEnd" [(ngModel)]="productEnd" (ngModelChange)="productEnd = setProductEnd($event)"
                    [ngModelOptions]="{standalone: true}" datePickerContainer=".productDateUntilContainer"
                    [disabled]="endDateDisabled">
                </sol-date-picker>
                <span class="error" *ngIf="validatorService.displayError(formDataBinding.controls['datesValidation'])">
                    {{validatorService.getErrorMessage(formDataBinding.controls['datesValidation'])}}
                </span>
            </div>
        </div>
        <!-- / -->
        <div class="row justify-content-start mb-8">
            <div class="col-6 col-md-6 col-lg-4">
                <label class="col-form-label text-uppercase cxone-label-title-form-element" cvLocalizedText langSection="MarketPlace_Management" langKey="Category">Category</label><span class="required-sign"> *</span>
                <sol-dropdown id="cxone-dropdown-category"
                                             formControlName="category"
                                             (selectionChange)="onCategorySelected($event)"
                                             (onCreate)="onCategoryCreate($event)"
                                             [optionsLabel]="'name'"
                                             [optionsValue]="'id'"
                                             [placeholder]="getLocalizationString('Select_Products_CXOne','Select...')"
                                             [options]="categoriesList"
                                             (dropdownOpenStateChange)="!$event && onCategoryDropdownClosed('category')"
                                             [loading]="false"
                                             [required]="true"
                                             [class]="validatorService.displayError(formDataBinding.controls['category']) ? 'error-selector' : ''"></sol-dropdown>
                    <div class="d-flex justify-content-between align-items-start">
                        <div>
                            <div class="error" *ngIf="formDataBinding.controls['category'].errors?.required && 
                                (formDataBinding.controls['category'].touched || formDataBinding.controls['category'].dirty)">
                                <span cvLocalizedText langSection="MarketPlace_Management_Messages" langKey="Field_Required">This field is required</span>
                            </div>
                            <div class="error" *ngIf="formDataBinding.controls['category'].errors?.maxlength && 
                                (formDataBinding.controls['category'].touched || formDataBinding.controls['category'].dirty)">
                                <span cvLocalizedText langSection="MarketPlace_Management_Messages" langKey="Entry_Long">This entry is
                                    too long.</span>
                            </div>
                            <div class="error" *ngIf="formDataBinding.controls['category'].hasError('forbiddenCharacters') && 
                                (formDataBinding.controls['category'].touched || formDataBinding.controls['category'].dirty)">
                                <span>{{ forbiddenCharactersMessage }}</span>
                            </div>
                        </div>
                    </div>
            </div>
            <div class="col-6 col-md-6 col-lg-4">
                <label class=" col-form-label text-uppercase cxone-label-title-form-element" cvLocalizedText langSection="MarketPlace_Management" langKey="SubCategory">SubCategory</label><span class="required-sign"> *</span>
                 <sol-dropdown id="cxone-dropdown-subcategory"
                                             formControlName="subCategory"
                                             (selectionChange)="onSubCategorySelected($event)"
                                             (onCreate)="onSubCategoryCreate($event)"
                                             [placeholder]="getLocalizationString('Select_Products_CXOne','Select...')"
                                             [options]="subCategoriesList" 
                                             [optionsLabel]="'name'"
                                             [optionsValue]="'id'" 
                                             [loading]="false" 
                                             [required]="true"
                                             (dropdownOpenStateChange)="!$event && onCategoryDropdownClosed('subCategory')"
                                            [class]="validatorService.displayError(formDataBinding.controls['subCategory']) ? 'error-selector' : ''"
                                             ></sol-dropdown>
                    <div class="d-flex justify-content-between align-items-start">
                        <div>
                            <div class="error" *ngIf="formDataBinding.controls['subCategory'].errors?.required && 
                                (formDataBinding.controls['subCategory'].touched || formDataBinding.controls['subCategory'].dirty)">
                                <span cvLocalizedText langSection="MarketPlace_Management_Messages" langKey="Field_Required">This field is required</span>
                            </div>
                            <div class="error" *ngIf="formDataBinding.controls['subCategory'].errors?.maxlength && 
                                (formDataBinding.controls['subCategory'].touched || formDataBinding.controls['subCategory'].dirty)">
                                <span cvLocalizedText langSection="MarketPlace_Management_Messages" langKey="Entry_Long">This entry is
                                    too long.</span>
                            </div>
                            <div class="error" *ngIf="formDataBinding.controls['subCategory'].hasError('forbiddenCharacters') && 
                                (formDataBinding.controls['subCategory'].touched || formDataBinding.controls['subCategory'].dirty)">
                                <span>{{ forbiddenCharactersMessage }}</span>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
        <!-- / -->
        <section style="margin-top: 64px;">
            <label cvLocalizedText
            langSection="MarketPlace_Management" langKey="Product_Variants" class="section-title">Product Variants</label>
            <hr class="m-0">
        <!-- multiple product variants section -->
        <div class="d-flex multiple-variants-container">
            <label cvLocalizedText
            langSection="MarketPlace_Management" langKey="Multiple_Product_Variants" class="text-uppercase cxone-label-title-form-element mb-0">Multiple Product variants</label>
            <div class="d-flex">
            <sol-slide-toggle class="cxone-slide-toggle-multiple-product-variants" slideOnColor="#007CBE"
                    toggleId="multipleProductVariants" name="smallToggle" [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="pspes.modifiedPointStoreProduct.HasProductVariations"
                    (clicked)="enableMultipleVariation($event)" styleClass="medium-toggle"></sol-slide-toggle>
                <label class="cxone-toggle-text-multiple-product-variants text-capitalize"
                cvLocalizedText langSection="MarketPlace_Management" langKey="No"
                    *ngIf="!pspes.modifiedPointStoreProduct?.HasProductVariations">No</label>
                <label class="cxone-toggle-text-multiple-product-variants text-capitalize" cvLocalizedText langSection="MarketPlace_Management" langKey="Yes"
                    *ngIf="pspes.modifiedPointStoreProduct?.HasProductVariations">Yes</label>
            </div>
        </div>

        <!-- price, variation type and diff prices -->
                    <div class="row d-flex">
                        <!-- price in coins section -->
                        <div class="col-12 col-md-6 col-lg-4 col-xl-4">
                            <label for="price" class="col-form-label text-uppercase cxone-label-title-form-element"><span cvLocalizedText langSection="MarketPlace_Management" langKey="Price">Price</span><span
                                    class="required-sign"> *</span></label>
                            <sol-text-input type="text" [disabled]="priceInputIsEnabled" class="text-input" id="price" cvInputNumericFormat [maxCharLength]="9" (keydown)="validatorService.preventLeadingZero($event, formDataBinding.controls['price'])" (keyup)="bindingPrice()"
                                (paste)="validateClipboardInput($event, formDataBinding.controls['price'])" formControlName="price" placeholder="{{getLocalizationString('Enter_Variant_Price','Enter price')}}" name="price"></sol-text-input>
                            <span class="error" *ngIf="validatorService.displayError(formDataBinding.controls['price'])">
                                {{validatorService.getErrorMessage(formDataBinding.controls['price'])}}
                            </span>
                        </div>
                        <!-- variant types -->
                        <div class="col-6 col-md-6 col-lg-4 col-xl-4" [hidden]="!pspes.modifiedPointStoreProduct?.HasProductVariations">
                            <label class="col-form-label text-uppercase cxone-label-title-form-element">
                                <span cvLocalizedText langSection="MarketPlace_Management"
                                    langKey="Variant_Type">Variant
                                    type</span>
                                <span class="required-sign"> *</span></label>
                            <sol-dropdown class="align-self-start" id="variationName" 
                                formControlName="variationName"
                                (selectionChange)="onVariationTypeSelected($event)"
                                [placeholder]="getLocalizationString('Select_Products_CXOne','Select...')"
                                [options]="variationTypes" 
                                [optionsLabel]="'name'" 
                                [optionsValue]="'id'" 
                                [loading]="false"                                
                                (dropdownOpenStateChange)="!$event && onCategoryDropdownClosed('variationName')"
                                [class]="validatorService.displayError(formDataBinding.controls['variationName']) ? 'error-selector' : ''"
                                (onCreate)="onCreateVariationType($event)">
                            </sol-dropdown>
                            <span class="error" *ngIf="validatorService.displayError(formDataBinding.controls['variationName'])">
                                {{validatorService.getErrorMessage(formDataBinding.controls['variationName'])}}
                            </span>
                        </div>
                        <!-- checkbox price variants -->
                        <div class="col-6 col-md-6 col-lg-4 col-xl-4" style="height: 85px;" [hidden]="!pspes.modifiedPointStoreProduct?.HasProductVariations">
                            <sol-checkbox style="position: relative; top: 47%;" type="checkbox" checkboxId="diffPrices" formControlName="diffPrices" (clicked)="setDiffPrices()"
                                >{{cvLocalizationService.getCachedText('MarketPlace_Management', 'Diff_Prices_Variants', 'Different prices for the variants')}}</sol-checkbox>
                        </div>
                    </div>
        <!-- end price, variation type and diff prices -->

        <!-- quantity -->
        <div class="row pt-3" [hidden]="pspes.modifiedPointStoreProduct?.HasProductVariations">
            <div class="col-12">
                <label class="col-form-label text-uppercase cxone-label-title-form-element" cvLocalizedText
                langSection="MarketPlace_Management" langKey="Quantity">Quantity</label><span
                    class="required-sign"> *</span>
            </div>
            <div class="col-12 d-flex flex-row">
                <sol-text-input id="cxone-input-quantity"
                    formControlName="quantity"
                    cvInputNumericFormat
                    [maxCharLength]="6"
                    type="text"
                    class="text-input"
                    placeholder="{{getLocalizationString('Enter_Quantity','Enter quantity')}}"
                    name="name"
                    (keyup)="bindingQuantity()"
                    (paste)="validateClipboardInput($event, formDataBinding.controls['quantity'])">
                </sol-text-input>
                <sol-checkbox id="cxone-checkbox-unlimited-quantity" 
                    [(ngModel)]="unlimitedQuantity"
                    [ngModelOptions]="{standalone: true}"
                    class="pl-4 pt-1" type="checkbox"
                    (ngModelChange)="markedUnlimitedQuantity()">{{getLocalizationString('Unlimited_Quantity','Unlimited Quantity')}}</sol-checkbox>
            </div>
            <div class="col-12">
                <span class="error" *ngIf="validatorService.displayError(formDataBinding.controls['quantity'])">
                    {{validatorService.getErrorMessage(formDataBinding.controls['quantity'])}}
                </span>
            </div>
        </div>
        <!-- end quantity -->

        <!-- variations -->
        <div class="w-100 pt-4 mb-4" style="max-width: 100%;" formArrayName="variants"
            *ngIf="pspes.modifiedPointStoreProduct?.HasProductVariations">
            <div class="row">
                <div class="col-12 col-md-4 col-lg-4 col-xl-4">
                    <label for="variationName0" class="col-form-label text-uppercase cxone-label-title-form-element">
                        <span cvLocalizedText langSection="MarketPlace_Management"
                                langKey="Variant_Name">Variant Name</span>
                        <span class="required-sign"> *</span>
                    </label>
                </div>
                <div *ngIf="diffPrices" class="col-12 col-md-2 col-lg-2 col-xl-2">
                    <label for="variationPrice0" class="col-form-label text-uppercase cxone-label-title-form-element">
                        <span cvLocalizedText langSection="MarketPlace_Management" langKey="Price">Price</span>
                        <span class="required-sign" *ngIf="formDataBinding.get('diffPrices').value">
                            *
                        </span>
                    </label>
                </div>
                <div class="col-12 col-md-2 col-lg-2 col-xl-2">
                    <label for="variationQuantity0" class="col-form-label text-uppercase cxone-label-title-form-element">
                        <span cvLocalizedText langSection="MarketPlace_Management"
                                langKey="Quantity">Quantity</span>
                        <span class="required-sign"> *</span>
                    </label>
                </div>
            </div>
            <div class="row justify-content-start align-items-start mb-3" [formGroupName]="i"
                *ngFor="let v of variantsForm.controls; index as i; let lastIndex = last">
                <div class="col-12 col-md-4 col-lg-4 col-xl-4">
                    <sol-text-input type="text" class="text-input" [id]="'variationName' + i"
                        (input)="trimVariantName(i);updateVariationModelValue(i, 1)"
                        (focusout)="trimVariantName(i, true)"
                        formControlName="variationName"
                        [placeholder]="cvLocalizationService.getCachedText('MarketPlace_Management', 'Enter_Variant_Name', 'Enter variant name')"
                        [name]="'variationName' + i"
                        (keyup)="updateVariationModelValue(i, 1)"></sol-text-input>
                    <div class="d-flex justify-content-between align-items-start">
                        <div>
                            <div class="error" *ngIf="getArrayControl(i).controls['variationName'].errors?.required && 
                                (getArrayControl(i).controls['variationName'].touched || getArrayControl(i).controls['variationName'].dirty)">
                                <span cvLocalizedText langSection="MarketPlace_Management_Messages" langKey="Field_Required">This field is required</span>
                            </div>
                            <div class="error" *ngIf="getArrayControl(i).controls['variationName'].errors?.distinct && 
                                (getArrayControl(i).controls['variationName'].touched || getArrayControl(i).controls['variationName'].dirty)">
                                <span cvLocalizedText langSection="MarketPlace_Management_Messages" langKey="Name_Already_Exists">This name already exists</span>
                            </div>
                            <div class="error" *ngIf="getArrayControl(i).controls['variationName'].hasError('forbiddenCharacters') && 
                                (getArrayControl(i).controls['variationName'].touched || getArrayControl(i).controls['variationName'].dirty)">
                                <span>{{ forbiddenCharactersMessage }}</span>
                            </div>
                            <div class="error" *ngIf="getArrayControl(i).controls['variationName'].errors?.maxlength && 
                                (getArrayControl(i).controls['variationName'].touched || getArrayControl(i).controls['variationName'].dirty)">
                                <span cvLocalizedText langSection="MarketPlace_Management_Messages" langKey="Entry_Long">This entry is too long.</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="diffPrices" class="col-12 col-md-2 col-lg-2 col-xl-2">
                    <sol-text-input type="text" class="text-input"
                        cvInputNumericFormat [maxCharLength]="9"
                        [id]="'variationPrice' + i"
                        formControlName="variationPrice"
                        [placeholder]="cvLocalizationService.getCachedText('MarketPlace_Management', 'Enter_Variant_Price', 'Enter price')"
                        [name]="'variationPrice' + i"
                        (keydown)="validatorService.preventLeadingZero($event, getControlFromArray(i, 'variationPrice'))"
                        (keyup)="updateVariationModelValue(i, 2)"
                        (input)="updateVariationModelValue(i, 2)"
                        (paste)="validateClipboardInput($event, getControlFromArray(i, 'variationPrice'))"></sol-text-input>
                    <span class="error" *ngIf="validatorService.displayError(getArrayControl(i).controls['variationPrice'])">
                        {{validatorService.getErrorMessage(getArrayControl(i).controls['variationPrice'])}}
                    </span>
                </div>
                <div class="col-6 col-md-2 col-lg-2 col-xl-2">
                    <sol-text-input type="text" class="text-input"
                        cvInputNumericFormat [maxCharLength]="6"
                        [returnEmptyString]="true"
                        [id]="'variationQuantity' + i" 
                        formControlName="variationQuantity"
                        [placeholder]="cvLocalizationService.getCachedText('MarketPlace_Management', 'Enter_Quantity', 'Enter quantity')"
                        [name]="'variationQuantity' + i"
                        (keyup)="updateVariationModelValue(i, 3)"
                        (input)="updateVariationModelValue(i, 3)"
                        (paste)="validateClipboardInput($event, getControlFromArray(i, 'variationQuantity'))"></sol-text-input>
                    <span class="error" *ngIf="validatorService.displayError(getArrayControl(i).controls['variationQuantity'])">
                        {{validatorService.getErrorMessage(getArrayControl(i).controls['variationQuantity'])}}
                    </span>
                </div>
                <div class="col-6 col-md-4 col-lg-4 col-xl-4 d-flex pt-1">
                    <sol-checkbox id="{{'cxone-checkbox-unlimited-quantity-variation' + i}}" class="pr-4" type="checkbox" (clicked)="disableVariantName(i)">{{getLocalizationString('Unlimited_Quantity', 'Unlimited Quantity')}}</sol-checkbox>
                    <div class="d-flex">
                        <div class="cursor-pointer" (click)="removeVariant(i)">
                            <svg class="icon-20 icons-variation close-wrapper" id="delete" [class.icons-variation-disabled]="!isRemoveVariantValid">
                                <use href="../App_Themes/CXone/icons/delete.svg#delete"></use>
                            </svg>
                        </div>
                        <div *ngIf="lastIndex && variantsForm.controls.length < 20" class="cursor-pointer" (click)="addNewVariant()">
                            <svg style="margin-left: 12px;" class="icon-20 icons-variation close-wrapper" id="add" [class.icons-variation-disabled]="!isAddVariantValid">
                                <use href="../App_Themes/CXone/icons/add.svg#add"></use>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </section>
    <!-- end variations -->
    <!-- end multiple product variants section -->
    </div>
</overlay-scrollbars>
